"use client"

import { Bell } from "lucide-react"
import { Button } from "@/components/ui/button"

interface NotificationsHeaderProps {
  unreadCount: number
  onMarkAllAsRead?: () => void
}

export function NotificationsHeader({ unreadCount, onMarkAllAsRead }: NotificationsHeaderProps) {
  return (
    <div className="flex items-center justify-between pb-6 border-b border-gray-200">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-blue-100 rounded-lg">
          <Bell className="w-6 h-6 text-blue-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Notifications</h1>
          <p className="text-sm text-gray-600">
            {unreadCount > 0
              ? `You have ${unreadCount} new notification${unreadCount !== 1 ? "s" : ""}`
              : "You're all caught up!"}
          </p>
        </div>
      </div>

      {unreadCount > 0 && onMarkAllAsRead && (
        <Button
          onClick={onMarkAllAsRead}
          variant="outline"
          className="text-blue-600 border-blue-200 hover:bg-blue-50 bg-transparent"
        >
          Mark all as read
        </Button>
      )}
    </div>
  )
}
